import Image from '../../Image';
import TeamDefault from '../../../common/components/images/team-default.svg';

import { useState } from 'react';

import Paginate from './Pagination';
import ArrowLongDownIcon from '../../../common/components/images/icons/arrow-down.svg';
import { IRanking } from '../../../modules/sport/interfaces/ranking';
import Link from '../../Link';
import { useHistory, useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function List(props): JSX.Element {
    const history = useHistory();
    const query = useQuery();
    const { rankings, filter, sport, attribute } = props;
    const [sort, setSort] = useState({ column: 'pos', asc: null });
    const [list, setList] = useState(rankings?.data?.data);
    const [open, setOpen] = useState(false);
    const [linkOpen, setlinkOpen] = useState('');
    const [teamName, setTeamName] = useState('');

    const handlerSort = (lColumn: string, field, type: string) => {
        setSort((old) => {
            const response = { column: lColumn, asc: old.asc === false ? null : !old.asc };
            setList(() => {
                const newData = [].concat(rankings?.data?.data);
                const sortData = newData.sort((a, b) =>
                    type === 'number' ? a[field] - b[field] : a[field].localeCompare(b[field]),
                );
                if (old.asc === null) {
                    return sortData;
                } else if (old.asc === true) {
                    return sortData.reverse();
                } else {
                    return rankings?.data?.data;
                }
            });
            return response;
        });
    };

    const setParams = (name: string, value: string) => {
        // Sets new parameters onto our URLSearchParams object
        query.set(name, value);

        // Pushes new parameters onto the current URL using URLSearchParams object toString method
        history.push({
            pathname: location.pathname,
            search: query.toString(),
        });
    };

    const changePage = (e, page) => {
        e.preventDefault();
        setParams('page', page);
    };
    //    console.log({ filter });

    return (
        <div
            key={'div-list-positions'}
            className={`pb-5 min-h-layout container mx-auto  lg:w-[70%] xl:w-[70%] w-full `}
        >
            {/*sm:w-[70%] md:w-[70%] */}

            {/*   POSITIONS TABLE */}

            <div className="xl:pt-6 lg:pt-6 pt-12">
                <h2 className="font-bold text-[22px] text-white text-center italic">RANKING SUPERMATCH</h2>
                <div className="my-10 px-6  relative overflow-x-auto">
                    <table className="w-full leading-normal rounded-lg ">
                        <thead className="contents text-white text-base rounded-lg font-semibold  tracking-wider px-5 py-3">
                            <tr className="">
                                <th
                                    scope="col"
                                    className="w-[70px] text-center py-3 pl-3 xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`cursor-pointer select-none flex items-center w-[50px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('pos', 'position', 'number')}
                                    >
                                        Pos
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'pos' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'pos' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="xl:w-3 lg:w-[20%] md:w-[6%] text-left text-gray-dark py-3 pl-6 xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`cursor-pointer select-none flex items-center w-[80px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('team', 'teamName', 'string')}
                                    >
                                        Equipo
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'team' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'team' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="xl:w-3 lg:w-[25%] md:w-full text-left text-gray-dark py-3 px-3 xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`cursor-pointer select-none flex items-center w-[80px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('owner', 'firstName', 'string')}
                                    >
                                        Capitán
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'owner' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'owner' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="w-[63px] text-gray-dark py-3 
                                    xl:w-full lg:w-[10%] md:w-[6%] text-center xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`items-center justify-center cursor-pointer select-none flex w-[40px] xl:w-full lg:w-full md:w-full`}
                                        onClick={() => handlerSort('pj', 'gamesPlayed', 'number')}
                                    >
                                        PJ
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'pj' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'pj' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="w-[63px] xl:w-full lg:w-[10%] md:w-[6%] text-gray-dark py-3  text-center xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`items-center justify-center cursor-pointer select-none flex w-[40px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('pg', 'gamesWon', 'number')}
                                    >
                                        PG
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'pg' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'pg' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="w-[63px] xl:w-full lg:w-[10%] md:w-[6%] text-gray-dark py-3 text-center xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`items-center justify-center cursor-pointer select-none flex w-[40px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('pe', 'gamesTie', 'number')}
                                    >
                                        PE
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'pe' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'pe' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="w-[63px] xl:w-full lg:w-[10%] md:w-[6%] text-gray-dark py-3 text-center xl:text-xl lg:text-lg font-semibold text-white tracking-wider"
                                >
                                    <div
                                        className={`items-center justify-center cursor-pointer select-none flex w-[40px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('pp', 'gamesLost', 'number')}
                                    >
                                        PP
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'pp' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'pp' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="w-[63px] xl:w-full lg:w-[10%] md:w-[6%] text-gray-dark py-3 text-center xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`items-center justify-center cursor-pointer select-none flex w-[50px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('pts', 'totalPoints', 'number')}
                                    >
                                        PTS
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'pts' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'pts' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    className="w-[63px] xl:w-full lg:w-[10%] md:w-[6%] text-gray-dark py-3 text-center xl:text-xl lg:text-lg font-semibold text-white tracking-wider italic"
                                >
                                    <div
                                        className={`items-center justify-center cursor-pointer select-none flex w-[65px] xl:w-full lg:w-full`}
                                        onClick={() => handlerSort('rend', 'performance', 'number')}
                                    >
                                        REND
                                        <span className={`text-base font-Raleway font-medium`}>
                                            {sort.column === 'rend' && sort.asc === false ? (
                                                <img
                                                    src={ArrowLongDownIcon}
                                                    alt={''}
                                                    className={``}
                                                    height={0}
                                                    width={20}
                                                />
                                            ) : (
                                                sort.column === 'rend' &&
                                                sort.asc && (
                                                    <img
                                                        src={ArrowLongDownIcon}
                                                        alt={''}
                                                        className={`rotate-180`}
                                                        height={0}
                                                        width={20}
                                                    />
                                                )
                                            )}
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {list &&
                                list?.length > 0 &&
                                list?.map((ranking: IRanking, i: number) => (
                                    <tr
                                        className={`hover:bg-gray-700 flex-col  border-b border-[#45516a]
                                        ${i % 2 === 0 ? 'bg-[#30313f]' : 'bg-[#3f4459]'}
                                        lg:h-[60px] xl:h-[60px] h-auto 
                                        xl:text-left lg:text-left text-center`}
                                        key={`details-${i}-${ranking.teamId}`}
                                    >
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <div className="flex-none items-center">
                                                <div className="xl:ml-3 lg:ml-3 ">
                                                    <p className="text-white whitespace-nowrap">
                                                        <span className="text-sm-rent font-bold pr-4 hidden">Pos:</span>
                                                        {filter.page === 1
                                                            ? i + 1
                                                            : filter.limit * (filter.page - 1) + 1 + i}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="py-1 px-2 xl:px-6 text-white text-sm xl:w-[50%] w-auto">
                                            <div className="xl:flex">
                                                <span className="text-sm-rent font-bold xl:pr-4 lg:pr-4 pr-0 hidden">
                                                    Equipo:
                                                </span>
                                                <div
                                                    className="my-auto
                                                xl:pt-0 pt-2
                                                grid place-items-center 
                                                "
                                                >
                                                    <div
                                                        onClick={() => {
                                                            const linkNew = `/${sport}${
                                                                attribute.url
                                                            }/equipos/filter?region=${
                                                                ranking?.regionId ? ranking?.regionId : filter.region
                                                            }&commune=${
                                                                ranking?.countyId
                                                            }&onlyAvailable=true&teamIdRankingFilter=${
                                                                ranking?.teamId
                                                            }&teamNameRankingFilter=${
                                                                ranking?.teamName
                                                            }&teamLogoRankingFilter=${ranking?.teamLogo}`;
                                                            setlinkOpen(linkNew);
                                                            setOpen(true);
                                                            setTeamName(ranking?.teamName);
                                                        }}
                                                    >
                                                        <Image
                                                            className={`
                                                            bg-gray-100
                                                            w-10 h-10
                                                            cursor-pointer
                                                              !rounded-full border-2 shadow-profile
                                                          border-sm-integrate `}
                                                            imgClassName={`rounded-full`}
                                                            src={ranking?.teamLogo ? ranking?.teamLogo : TeamDefault}
                                                            alt="Logo del equipo"
                                                            height={35}
                                                            width={35}
                                                        />
                                                    </div>
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        const linkNew = `/${sport}${
                                                            attribute.url
                                                        }/equipos/filter?region=${
                                                            ranking?.regionId ? ranking?.regionId : filter.region
                                                        }&commune=${
                                                            ranking?.countyId
                                                        }&onlyAvailable=true&teamIdRankingFilter=${
                                                            ranking?.teamId
                                                        }&teamNameRankingFilter=${
                                                            ranking?.teamName
                                                        }&teamLogoRankingFilter=${ranking?.teamLogo}`;
                                                        setlinkOpen(linkNew);
                                                        setOpen(true);
                                                        setTeamName(ranking?.teamName);
                                                    }}
                                                >
                                                    <span className="my-auto block xl:pl-5 xl:text-left text-center py-2 xl:w-[100%] lg:w-[100%]">
                                                        {ranking.teamName}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="py-2 px-2 xl:px-3 text-white text-sm xl:w-[50%] text-left w-auto">
                                            <span className="text-sm-rent font-bold pr-4 hidden">Capitán:</span>
                                            <span>
                                                {ranking.firstName} {ranking.lastName}
                                            </span>
                                        </td>
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <span className="text-sm-rent font-bold pr-4 hidden">PJ:</span>
                                            <span>{ranking.gamesPlayed}</span>
                                        </td>
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <span className="text-sm-rent font-bold pr-4 hidden">PG:</span>
                                            <span>{ranking.gamesWon}</span>
                                        </td>
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <span className="text-sm-rent font-bold pr-4 hidden">PE:</span>
                                            <span>{ranking.gamesTie}</span>
                                        </td>
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <span className="text-sm-rent font-bold pr-4 hidden">PP:</span>
                                            <span>{ranking.gamesLost}</span>
                                        </td>
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <span className="text-sm-rent font-bold pr-4 hidden">PTS:</span>
                                            <span>{ranking.totalPoints}</span>
                                        </td>
                                        <td className="py-4 px-2 xl:px-6 text-white text-sm text-center">
                                            <span className="text-sm-rent font-bold pr-4 hidden">REND:</span>
                                            <span>{(ranking.performance * 100).toFixed(0)}%</span>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                {rankings && rankings.data && rankings?.data?.data.length > 0 && (
                    <div className="pt-10">
                        <Paginate
                            pages={Number(rankings?.data?.pages)}
                            page={Number(rankings?.data?.page) || 1}
                            limit={5}
                            next={changePage}
                            previous={changePage}
                        />
                    </div>
                )}
                {open && (
                    <div className="fixed z-50  p-4  right-2 md:right-12  bottom-16 lg:overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full flex justify-center items-center ">
                        <div className="relative w-full max-w-md max-h-full">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button
                                    type="button"
                                    className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                    onClick={() => setOpen(false)}
                                >
                                    <svg
                                        className="w-3 h-3"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 14 14"
                                    >
                                        <path
                                            stroke="currentColor"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                        />
                                    </svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <div onClick={() => setOpen(false)}>
                                        <svg
                                            className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                            />
                                        </svg>
                                    </div>

                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                        ¿Estás seguro que desea desafíar este Equipo ?
                                    </h3>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                        {teamName}
                                    </h3>
                                    <Link to={linkOpen}>
                                        <div className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                            Si
                                        </div>
                                    </Link>

                                    <button
                                        onClick={() => setOpen(false)}
                                        type="button"
                                        className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
